<template>
  <v-container class="no-margins">
    <v-card flat>
      <v-icon size="20" class="close" @click="$emit('close')">$sl-close</v-icon>
      <h2>{{ $t("company.qr1-title") }}</h2>
    </v-card>
    <v-card flat class="certificate mb-2" width="300">
      <v-card-title>
        <h2 v-if="isInstructor==false">{{ $t("company.qualification-title") }}</h2>
        <h1 v-if="isGU == true">{{ $t("company.qualification-title2") }}</h1>
        <h1 class="pt-6" v-else-if="isInstructor == true">{{ $t("company.qualification-title-instructor") }}</h1>
        <h1 v-else>{{ $t("labels.apprentice") }}</h1>
      </v-card-title>
      <v-card-text>
        <!-- <h3>{{ $t('company.qualification-subtitle')}}</h3> -->
        <h4>
          {{ (currentUser.firstName || "") + " " + (currentUser.lastName || "") }}
        </h4>
        <h5>{{ currentUser.personalNumber | persno }}</h5>
        <h4 class="mt-5 smaller" v-if="isGU == true">
          {{ $t("company.qualification-gu-subtitle") }}
        </h4>
        <h4 class="mt-5 smaller" v-else-if="isInstructor == true">
          {{ $t("company.qualification-inst-subtitle") }}
        </h4>
        <h4 class="mt-5 smaller" v-else>
          {{ $t("company.qualification-qTime-subtitle") }}
        </h4>
        <template v-if="isInstructor==true">
          <div v-for="(item, index) in instructorItems" :key="'item_' + index">
            <div class="d-flex justify-center" v-if="item.profession">
              <h6 class="mb-3 mx-n1">{{ item.profession.name }}</h6>
            </div>          
            
            <template v-if="item.profession && hasProfessionOrientations(item.profession.id) && item.machineOrientations">
              <p v-for="(po, i) in item.machineOrientations" :key="'po_' + i" class="machines">
                {{ po.machine.name || '-'}} | {{ get(po, 'issuedOn', '') | date }}
              </p>
            </template>
            <p v-else class="machines">
              {{ item.profession.name }} | {{ get(item, 'issuedOn', '') | date }}
            </p>
          </div>          
            <p class="mt-6">{{ $t("company.qualification-inst-text") }}</p>

            <p class="mt-6" v-if="items && items.length>0">{{ $t("company.qualification-text3") }} <span class="text-uppercase">{{getRegionNameById(items[items.length-1].regionId)}}</span></p>
            <p class="" v-if="items && items.length>0">
              {{ $t("company.qualification-date2") }}: {{ get(items[items.length-1], 'issuedOn', '') | date }}
            </p>
            <p class="mb-8" v-if="items && items.length>0">
              {{ $t("company.qualification-cardno") }}: {{ items[items.length-1].id }}
            </p>
          </template>
          <template v-else>
            <div class="d-flex justify-center">
              <h6 class="mb-3">{{ $t("company.qualification-subtitle3") }}</h6>
            </div>
            <!-- <p class="machines" v-if="selectedMachine.machine && selectedMachine.machine.name">{{ selectedMachine.machine.name }}</p> -->
            <p class="machines" v-for="(m, index) in items" :key="'ma_' + index">
              {{ m.machine ? m.machine.name : "" }}
            </p>
            <p class="mt-6" v-if="isGU == true">{{ $t("company.qualification-text") }}</p>
            <p class="mt-6" v-else>{{ $t("company.qualification-text-qtime") }}</p>
            <p class="mt-6">{{ $t("company.qualification-text2") }}</p>
            <p class="" v-if="date && date.startDate">
              {{ $t("company.qualification-date") }}: {{ date.startDate | date }}
            </p>
            <p class="mb-8" v-if="date && date.endDate">
              {{ $t("company.qualification-end-date") }}: {{ date.endDate | date }}
            </p>
          </template>
          </v-card-text>
          <v-card-actions>
        <v-icon class="logo">$sl-logo-negativ</v-icon>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import sortBy from "lodash/sortBy";
import API from "@/services/api.js";
import get from 'lodash/get'
// @group Ebook
// Styled EbookElementModal component
export default {
  name: "qualificationModal",

  props: {
    isGU: {
      type: Boolean,
      default: false,
    },
  
    isInstructor: {
      type: Boolean,
      default: false,
    },
    machineItems: {
      type: Array,
      default: [],
    },
    
    items: {
      type: Array,
      default: [],
    },
    
    date: {
      type: Object,
      default: null,
    },
  },

  filters: {
    persno: function (value) {
      if (!value || value.length < 10) return "";
      return value.substring(2, 8) + "-" + value.substring(8, 12);
    },
  },
  data: () => ({
    instructorItems: []
  }),

  created() {
    this.init();
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser"]),
    ...mapGetters("basic", [
      "basicProfessions",
      "getRegionNameById",
      "hasProfessionOrientations",
      "getProfessionNameById",
      "getProfessionById",
    ]),
  },

  methods: {
    get,

    init() { 
      this.instructorItems = sortBy(this.items, 'approvedOn' )                      
    },
    /**
     * @vuese
     * Used to get specific book based on id
     * @arg the argument is a integer representing book id
     */
  },
};
</script>
